import BestOfferPriceDetailsOptionsDetails from '@ui/Accommodation/BestOffer/PriceDetails/OptionsDetails/component'
import accommodationCard, { initImagesSlider } from '@ui/Accommodation/Card/component'
import { createXhr as coreCommonCreateXhr, debounce, isDesktop } from 'assets/core/js/common'
import dataLayer from 'assets/core/js/module/dataLayer'
import ElementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import { PartialsEvents } from 'assets/core/js/module/partialsManager'
import { initZoomMediasPanel } from 'assets/core/js/page/product/zoomMediasPanel'
import { openCalendar } from './calendar'
import { createSidePanel } from './side-panels/accommodation'
import type { SidePanelType } from '@ui/SidePanel/component'
import type { Slider } from '@ui/Slider/component'

const readOffer = (url: string | null): void => {
  if (!url) {
    return
  }
  coreCommonCreateXhr('POST', url).send()
}

const openSidePanel = (card: HTMLElement): void => {
  let sidePanel: SidePanelType | undefined
  const sidePanelExists = ElementPropertiesManager.hasProperty(card, 'sidePanel')

  if (!sidePanelExists) {
    readOffer(card.getAttribute('data-read-offer-url'))

    const sidePanelId = card.getAttribute('data-sidepanel-id') as string
    const sidePanelUrl = card.getAttribute('data-sidepanel-url') as string
    const sidePanelType = card.getAttribute('data-sidepanel-type') as 'accommodation' | 'pitch'
    const accommodationId = card.getAttribute('data-id') ?? ''
    sidePanel = createSidePanel(sidePanelId, sidePanelUrl, sidePanelType, accommodationId)

    ElementPropertiesManager.addProperty(card, 'sidePanel', sidePanel)
  }

  sidePanel = ElementPropertiesManager.getProperty<SidePanelType>(card, 'sidePanel')
  sidePanel?.open()
}

const initCards = (): void => {
  document.querySelectorAll<HTMLElement>('.accommodation-card').forEach((el) => {
    accommodationCard(el, {
      onClickCard: openSidePanel,
      onClickPropertiesViewMoreBtn: openSidePanel,
      onClickImage: (card, image) => {
        if (!isDesktop()) {
          openSidePanel(card)
        } else {
          initZoomMediasPanel(image)
        }
      },
      onClickDetailsBtn: openSidePanel,
      onClickBestOfferBtn: (card, button) => {
        if (button.closest('form[name="checkOffer"]')) {
          return
        }

        if (!card.hasAttribute('data-checkin-date')) {
          openCalendar(button)
          return
        }

        openSidePanel(card)
      },
      onClickChangeDateBtn: (_card, button) => {
        openCalendar(button)
      },
      onClickPlanBtn() {
        dataLayer.pushInLayer(window.coreGtmId, {
          event: dataLayer.events.ACCOMMODATION_PLAN_VIEW,
        })
      },
      enableImagesSlider: isDesktop(),
    })

    // Initialize the PriceDetails:OptionsDetails component if there is one.
    const bestOfferPriceDetailsOptionsDetailsElement = el.querySelector<HTMLElement>('.accommodation-card-best-offer-price-details-options-details')
    if (bestOfferPriceDetailsOptionsDetailsElement) {
      BestOfferPriceDetailsOptionsDetails(bestOfferPriceDetailsOptionsDetailsElement)
    }
  })

  const resizeFn = debounce(100, () => {
    document.querySelectorAll<HTMLElement>('.accommodation-card').forEach((el) => {
      const imagesSliderEl = el.querySelector<HTMLElement>('.accommodation-card__images .slider')

      if (!imagesSliderEl) {
        return
      }

      const slider = ElementPropertiesManager.getProperty<Slider>(imagesSliderEl, 'slider')

      if (isDesktop() && !slider) {
        initImagesSlider(el)
        window.removeEventListener('resize', resizeFn)
      }
    })
  })

  window.addEventListener('resize', resizeFn)
}

export default function (): void {
  const resultsEl = document.querySelector('[data-partial-id="results"]')

  if (!resultsEl) {
    return
  }

  resultsEl.addEventListener(PartialsEvents.POST_UPDATE, () => {
    initCards()
  })

  // don't init the cards if the page is in progress of updating the results list
  if (!resultsEl.hasAttribute('data-partial-status')) {
    initCards()
  }
}
